export enum ReactionType {
    Like = 'LIKE',
    Dislike = 'DISLIKE',
    Approved = 'APPROVED',
    Rejected = 'REJECTED',
}
